import api from "../../shared/helpers/api";

const initialState = {
	modo: 2,
	nota: {
		tipoDoc: 3,
		tipoNota: "",
		numeroDoc: "",
		esNota: false,
	},
	comprobante: {
		id: null,
		tipoDoc: 1,
		numeroDoc: "",
		fechaEmision: "",
		transaccion: 1,
		moneda: 1,
		tipoPago: 2,
		pagoDias: "",
		observaciones: "",
		emitirNota: false,
	},
	cliente: {
		agencia: "",
		denominacion: "",
		tipoDoc: "6",
		numeroDoc: "",
		direccion: "",
		email: "",
		agenciaOld: "",
		cambiarPorPasajero: false,
	},
	items: [],
	anulado: {
		fecha: "",
		motivo: "",
		author: "",
	},
	containers: {
		comprobanteTiposDoc: [],
		monedas: [],
		transacciones: [],
		tiposPago: [],
		agencias: [],
		clienteTiposDoc: [],
		tiposIgv: [],
		facturado: null,
		notaTiposDoc: [],
		tiposNotaCredito: [],
		tiposNotaDebito: [],
	},
	loading: {
		view: true,
		numeroDoc: false,
		notaNumeroDoc: false,
		save: false,
	},
};

const initialItem = {
	// id: `${new Date().getTime()}_${state.items.length + 1}`,
	tempDescripcion: "",
	tempDescripcionOld: "",
	tempCantidad: 1,
	tempPrecioUnitario: 0,
	valorUnitario: 0,
	subtotal: 0,
	igv: 0,
	total: 0,
};

const comprobanteStore2 = {
	namespaced: true,
	state: () => ({ ...initialState }),
	mutations: {
		updateModo: (state, modo) => {
			state.modo = modo;
		},
		updateContainers(state, containers) {
			state.containers = { ...state.containers, ...containers };
		},
		updateNota(state, nota) {
			state.nota = { ...state.nota, ...nota };
		},
		updateComprobante(state, comprobante) {
			state.comprobante = { ...state.comprobante, ...comprobante };
		},
		updateCliente(state, cliente) {
			state.cliente = { ...state.cliente, ...cliente };
		},
		updateAnulado(state, anulado) {
			state.anulado = { ...state.anulado, ...anulado };
		},
		updateLoading(state, loading) {
			state.loading = { ...state.loading, ...loading };
		},
		updateFacturado(state, facturado) {
			state.containers.facturado = facturado;
		},
		updateItems(state, items) {
			state.items = [...items];
		},
		clear(state) {
			// state = { ...initialState };
			state.nota = { ...initialState.nota };
			state.comprobante = { ...initialState.comprobante };
			state.cliente = { ...initialState.cliente };
			state.anulado = { ...initialState.anulado };
			state.containers = { ...initialState.containers };
			state.loading = { ...initialState.loading };
			state.items = [];
			state.modo = 2;
		},
	},
	getters: {
		loading: (state) => state.loading,
		containers: (state) => state.containers,
		serie: (state) => {
			switch (state.comprobante?.tipoDoc) {
				case 1:
					return "F001";
				case 2:
					return "B001";
				default:
					return "";
			}
		},
		serieNota: (state) => {
			switch (state.comprobante?.tipoDoc) {
				case 1:
					return "F001";
				case 2:
					return "B001";
				default:
					return "";
			}
		},
		getComprobanteTipoDoc: (state, getters) => {
			if (getters.esNota) {
				return getters.esNotaCredito ? "NOTA DE CRÉDITO ELECTRÓNICA" : "NOTA DE DÉBITO ELECTRÓNICA";
			}
			return getters.esFactura ? "FACTURA DE VENTA ELECTRÓNICA" : "BOLETA DE VENTA ELECTRÓNICA";
		},
		getComprobanteSerie: (state, getters) => {
			if (getters.esNota) {
				return getters.serieNota;
			}
			return getters.serie;
		},
		getComprobanteNumeroDoc: (state, getters) => {
			if (getters.esNota) {
				return state.nota.numeroDoc;
			}
			return getters.numeroDoc;
		},
		getComprobanteAsociadoTipoDoc: (state, getters) => {
			if (!getters.esNota) return "";
			return getters.esFactura ? "FACTURA" : "BOLETA";
		},
		getComprobanteAsociadoSerie: (state, getters) => {
			if (!getters.esNota) return "";
			return getters.serie;
		},
		getComprobanteAsociadoNumeroDoc: (state, getters) => {
			if (!getters.esNota) return "";
			return getters.numeroDoc;
		},
		numeroDoc: (state) => state.comprobante.numeroDoc,
		estaAnulado: (state) => !!state.anulado.fecha,
		estaFacturado: (state) => !!state.containers?.facturado,
		esPagoAlCredito: (state) => state.comprobante.tipoPago == 3,
		esModoVista: (state) => state.modo == 0,
		esModoAutomatico: (state) => state.modo == 1,
		esModoManual: (state) => state.modo == 2,
		emitirNota: (state) => state.comprobante.emitirNota,
		esFactura: (state) => state.comprobante.tipoDoc == 1,
		esNota: (state) => state.nota.esNota,
		esNotaCredito: (state) => state.nota.tipoDoc == 3,
		esOtroCliente: (state) => state.cliente.agencia === 0,
		tiposNota: (state, getters) => (getters.esNotaCredito ? state.containers.tiposNotaCredito : state.containers.tiposNotaDebito),
		agenciaSelected: (state) => state.containers.agencias.find((item) => item.idAgencia == state.cliente.agencia),
		monedaSelected: (state) => state.containers.monedas.find((item) => item.idMoneda == state.comprobante.moneda),
		comprobanteTipoDocSelected: (state) => state.containers.comprobanteTiposDoc.find((item) => item.idDocVenta == state.comprobante.tipoDoc),
		tipoPagoSelected: (state) => state.containers.tiposPago.find((item) => item.idPagoTipo == state.comprobante.tipoPago),
		tipoIgv: (state) => {
			const idTransaccion = state.comprobante.transaccion;

			if (!idTransaccion) return;

			const idTipoIgvPorIdTransaccion = {
				1: 1,
				2: 16,
				4: 1,
				29: 16,
			};

			const idIgvTipo = idTipoIgvPorIdTransaccion[idTransaccion];

			return state.containers.tiposIgv.find((item) => item.idIgvTipo == idIgvTipo);
		},
		afectaIgv: (state, getters) => {
			return getters.tipoIgv?.afectaIGV == 1;
		},
		total(state, getters) {
			const itemsConIgv = state.items.filter((item) => getters.afectaIgv);
			const itemsSinIgv = state.items.filter((item) => !getters.afectaIgv && getters.tipoIgv?.comprobantetotal != "Gratuita");
			const itemsGratuitas = state.items.filter((item) => !getters.afectaIgv && getters.tipoIgv?.comprobantetotal == "Gratuita");
			const itemsExonerada = itemsSinIgv.filter((item) => getters.tipoIgv?.comprobantetotal == "Exonerada");
			const itemsInafecta = itemsSinIgv.filter((item) => getters.tipoIgv?.comprobantetotal == "Inafecta");

			console.log(
				"itemsConIgv",
				itemsConIgv.map((item) => item.subtotal)
			);

			const sumaSubTotalesConIgv = itemsConIgv.reduce((acc, item) => acc + Number(item.subtotal), 0);
			const sumaIgv = itemsConIgv.reduce((acc, item) => acc + Number(item.igv), 0);
			const sumaExoneradas = itemsExonerada.reduce((acc, item) => acc + Number(item.subtotal), 0);
			const sumaInafectas = itemsInafecta.reduce((acc, item) => acc + Number(item.subtotal), 0);
			const sumaSubTotalesGratuita = itemsGratuitas.reduce((acc, item) => acc + Number(item.subtotal), 0);

			let totalGravada = sumaSubTotalesConIgv;
			let totalExonerada = sumaExoneradas;
			let totalInafecta = sumaInafectas;
			let totalSinIgv = totalExonerada + totalInafecta;
			let totalIgv = sumaIgv;
			let totalGratuita = sumaSubTotalesGratuita;
			let total = totalGravada + totalSinIgv + totalIgv;

			return {
				gravada: totalGravada.toFixed(2),
				exonerada: totalExonerada.toFixed(2),
				inafecta: totalInafecta.toFixed(2),
				sinIgv: totalSinIgv.toFixed(2),
				igv: totalIgv.toFixed(2),
				gratuita: totalGratuita.toFixed(2),
				total: total.toFixed(2),
			};
		},
		pasajeros(state) {
			let pasajeros = [];
			state.items.forEach((item) => {
				const match = item.descripcion.match(/\| P: (?<pasajero>.+) \|/);
				if (match && (match[1] ?? null)) pasajeros.push(match[1]);
			});

			pasajeros = [...new Set(pasajeros)];

			return pasajeros;
		},
		modo: (state) => state.modo,
		disableItems: (_, getters) => {
			if (getters.esModoVista) return true;

			if (getters.emitirNota) return false;

			if (getters.estaFacturado) return true;

			return false;
		},
		disableGenerarComprobante: (state, getters) => {
			if (getters.esModoVista) return true;

			if (getters.emitirNota) return false;

			if (getters.estaFacturado) return true;

			return false;
		},
	},
	actions: {
		async load({ commit, getters }, { modo, nota, comprobante, cliente, anulado, containers, items }) {
			containers = {
				...containers,
				agencias: [
					...containers.agencias,
					{
						idAgencia: 0,
						nombre: "OTROS",
					},
				],
			};

			commit("updateContainers", containers);
			commit("updateModo", modo);

			commit("updateNota", nota);

			if (getters.esNota) {
				const fieldName = getters.esNotaCredito ? "idNotaCreditoTipo" : "idNotaDebitoTipo";
				const tipoNota = getters.tiposNota.find((item) => item[fieldName] == nota.tipoNota);

				commit("updateNota", {
					tipoNota,
				});
			}

			commit("updateComprobante", comprobante);
			commit("updateAnulado", anulado);
			commit("updateCliente", cliente);

			if (getters.esModoAutomatico) {
				commit("updateCliente", {
					tipoDoc: getters.containers.clienteTiposDoc.find((item) => item.idDocTipo == getters.agenciaSelected.idDocTipo)?.codigo || "6",
					numeroDoc: getters.agenciaSelected?.ruc || "",
					direccion: getters.agenciaSelected?.direccion || "",
					email: getters.agenciaSelected?.email || "",
				});
			}

			const tempItems = items.map((item, index) => ({
				id: `${new Date().getTime()}_${index + 1}`,
				...initialItem,
				...item,
				tempDescripcion: item.descripcion,
				tempDescripcionOld: "",
				tempCantidad: Number(item.cantidad),
				tempPrecioUnitario: Number(item.precioUnitario),
			}));

			commit("updateItems", tempItems);
			commit("updateLoading", { view: false });
		},

		async startGenerar({ commit, state, getters }) {
			const items = state.items.map((item) => ({
				idLiquidacion: item?.idLiquidacion || null,
				descripcion: item.tempDescripcion,
				tipoIgv: getters.tipoIgv.idIgvTipo,
				cantidad: item.tempCantidad,
				precioUnitario: item.tempPrecioUnitario,
				valorUnitario: item.valorUnitario,
				subtotal: item.subtotal,
				igv: item.igv,
				total: item.total,
			}));

			const fd = {
				notaTipoDoc: state.nota.tipoDoc,
				notaSerie: getters.serieNota,
				notaTipoNota: getters.esNotaCredito ? state.nota.tipoNota?.idNotaCreditoTipo : state.nota.tipoNota?.idNotaDebitoTipo,
				comprobanteTipo: state.comprobante.tipoDoc,
				comprobanteSerie: getters.serie,
				fechaEmision: state.comprobante.fechaEmision,
				transaccion: state.comprobante.transaccion,
				moneda: state.comprobante.moneda,
				pagoTipo: state.comprobante.tipoPago,
				pagoDias: state.comprobante.pagoDias || null,
				observaciones: state.comprobante.observaciones,
				agencia: getters.esOtroCliente ? null : state.cliente.agencia,
				denominacion: getters.esOtroCliente ? state.cliente.denominacion : null,
				tipoDoc: state.cliente.tipoDoc,
				numeroDoc: state.cliente.numeroDoc,
				direccion: state.cliente.direccion,
				email: state.cliente.email,
				items: items,
				total: getters.total,
				modo: state.modo,
			};

			commit("updateLoading", { save: true });

			let result = false;

			try {
				const endpoint = getters.emitirNota ? `/comprobantes/${state.comprobante.id}/nota` : "/comprobantes";

				const response = await api.post(endpoint, fd);

				commit("updateFacturado", response.data.content.comprobante);
				commit(
					"updateItems",
					state.items.map((item) => ({
						...item,
						descripcion: item.tempDescripcion,
						cantidad: item.tempCantidad,
						precioUnitario: Number(item.tempPrecioUnitario).toFixed(2),
					}))
				);

				commit("updateCliente", {
					denominacion: getters.esOtroCliente ? state.cliente.denominacion : getters.agenciaSelected.nombre,
				});

				commit("updateModo", 0);

				result = true;
			} catch (error) {
				console.error(error?.response || error);
			} finally {
				commit("updateLoading", { save: false });
			}
			return result;
		},
		addItem({ commit, state }) {
			commit("updateItems", [
				...state.items,
				{
					...initialItem,
					id: `${new Date().getTime()}_${state.items.length + 1}`,
				},
			]);
		},
		removeItem({ commit, state }, id) {
			commit(
				"updateItems",
				state.items.filter((item) => item.id !== id)
			);
		},
		async fetchNotaNumeroDoc({ commit, getters }, idTipoDoc) {
			console.log("watch nota.tipo");

			if (getters.esModoVista) return;

			commit("updateNota", { tipoNota: "", numeroDoc: "" });

			if (!idTipoDoc) {
				return;
			}

			commit("updateLoading", { notaNumeroDoc: true });

			try {
				const response = await api.post("/comprobantes/numero", {
					idDocVenta: idTipoDoc,
					serie: getters.serieNota,
				});

				commit("updateNota", { numeroDoc: response.data.content });
			} catch (error) {
				console.error(error?.response || error);
			} finally {
				commit("updateLoading", { notaNumeroDoc: false });
			}
		},
		async fetchComprobanteNumeroDoc({ commit, getters }, idTipoDoc) {
			console.log("watch comprobante.tipo");

			if (getters.esModoVista) return;

			commit("updateComprobante", { numeroDoc: "" });

			if (!idTipoDoc) {
				return;
			}

			commit("updateLoading", { numeroDoc: true });

			try {
				const response = await api.post("/comprobantes/numero", {
					idDocVenta: idTipoDoc,
				});

				commit("updateComprobante", { numeroDoc: response.data.content });
			} catch (error) {
				console.error(error?.response || error);
			} finally {
				commit("updateLoading", { numeroDoc: false });
			}
		},
		changeClienteAgencia({ state, commit, getters: { agenciaSelected } }, idAgencia) {
			if (!idAgencia) {
				commit("updateCliente", {
					denominacion: state.cliente.cambiarPorPasajero ? state.cliente.denominacion : "",
					tipoDoc: "6",
					numeroDoc: "",
					direccion: "",
					email: "",
					agencia: idAgencia,
				});
				return;
			}

			const cliente = {
				tipoDoc: state.containers.clienteTiposDoc.find((item) => item.idDocTipo == agenciaSelected.idDocTipo)?.codigo || "6",
				numeroDoc: agenciaSelected?.ruc || "",
				direccion: agenciaSelected?.direccion || "",
				email: agenciaSelected?.email || "",
			};

			commit("updateCliente", cliente);
		},
		cambiarPorPasajero({ commit, state, getters }, checked) {

			if (getters.pasajeros.length != 1) return;

			const items = state.items.map((item) => {
				let descripcion = item.tempDescripcion.split(" | ");
				descripcion = descripcion.length == 3 ? [descripcion[0], descripcion[2]].join(" | ") : item.tempDescripcion;

				return {
					...item,
					tempDescripcion: checked ? descripcion : item?.tempDescripcionOld || item.tempDescripcion,
					tempDescripcionOld: item.tempDescripcion,
				};
			});

			commit("updateCliente", {
				agencia: checked ? 0 : state.cliente.agenciaOld,
				agenciaOld: checked ? state.cliente.agencia : null,
				denominacion: checked ? getters.pasajeros[0] : "",
			});

			commit("updateItems", items);
		},
	},
};

export default comprobanteStore2;
